import {IChatSetting, eChatSettingModel} from "@listat/r2-core";
import {BehaviorSubject, Observable} from "rxjs";

export interface IQuickAction {
    value: string;
    title: string;
}

export interface ISkill {
    title: string;
    model: eChatSettingModel;
    prompt: string;
}

export abstract class ChatSettingBase {
    public abstract $getSetting(): Observable<IChatSetting>;
    public abstract getSetting(): IChatSetting;
    public abstract getSettingOriginal<T>(): T
    public abstract setSetting(newSetting: IChatSetting): IChatSetting;
    public abstract getQuickActionsDefault(): IQuickAction[];
    public abstract $getQuickActions(): Observable<IQuickAction[]>;
    public abstract setQuickActions(quickActions: IQuickAction[]): IQuickAction[];
    public abstract $getSkills(): Observable<ISkill[]>;
    public abstract setSkills(skills: ISkill[]): ISkill[];

    private currentQuickAction: BehaviorSubject<IQuickAction | null> = new BehaviorSubject<IQuickAction | null>(null)
    private currentSkill: BehaviorSubject<ISkill | null> = new BehaviorSubject<ISkill | null>(null)
    public onDestroy(): void {}

    public setCurrentQuickAction(quickAction: IQuickAction | null): void {
        if (quickAction) { this.currentSkill.next(null); }
        this.currentQuickAction.next(quickAction);
    }

    public getCurrentQuickAction(): IQuickAction | null {
        return this.currentQuickAction.getValue()
    }

    public $getCurrentQuickAction(): Observable<IQuickAction | null> {
        return this.currentQuickAction.asObservable()
    }

    public setCurrentSkill(skill: ISkill | null): void {
        if (skill) { this.currentQuickAction.next(null); }
        this.currentSkill.next(skill);
    }

    public getCurrentSkill(): ISkill | null {
        return this.currentSkill.getValue()
    }

    public $getCurrentSkill(): Observable<ISkill | null> {
        return this.currentSkill.asObservable()
    }
}
